import getItems from "./getItems";

const checkLocationIsFromSiderMenu = (role, location) => {
  const menuItems = getItems(role);
  return menuItems.some(menuItem => menuItem.key === location);
}

export default checkLocationIsFromSiderMenu;
